import { useState } from 'react';
import { useTranslation } from '../useTranslation';
import { useContainer } from '../useContainer';
import { ToastStateHandler } from '../../api';

export const useReportExport = () => {
    const { t } = useTranslation('reportsAbsence');
    const toastHandler = useContainer(ToastStateHandler);
    const [isExportingExcel, setIsExportingExcel] = useState(false);
    const [isExportingPdf, setIsExportingPdf] = useState(false);

    const runExport = async (kind: 'excel' | 'pdf', task: () => Promise<void>) => {
        const setIsExporting = kind === 'excel' ? setIsExportingExcel : setIsExportingPdf;
        setIsExporting(true);
        try {
            await task();
        } catch (e) {
            console.error(`Failed to generate ${kind} report`, e);
            toastHandler.push('error', t('generateReport'), t('generateReportPanel.exportError'));
        } finally {
            setIsExporting(false);
        }
    };

    return { isExportingExcel, isExportingPdf, runExport };
};
